'use client';

import Image from 'next/image';
import { MapLocatorPopupProps } from './types';
import { toTitleCase, getDistance, getOpenStatus, isOpen247 } from './utils';
import * as m from 'motion/react-m';

export const MapLocatorPopup = ({ location, userCoords, showAnimation }: MapLocatorPopupProps) => {
  return (
    <m.div
      data-testid="location-popup"
      animate={showAnimation ? { opacity: [0, 1], y: [40, 0], x: ['-50%', '-50%'] } : { x: '-50%' }}
      transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
      className="absolute left-1/2 bottom-[30px] bg-bg-primary px-6 py-3 rounded-lg text-base text-kale z-[1000] pointer-events-auto font-sans font-normal w-[calc(100%-50px)]">
      <div className="flex gap-4 text-left font-medium">
        <div>
          {location.merchant_logo ? (
            <Image
              src={`/map/icons/${location.merchant_logo}.webp`}
              alt={location.name + ' logo'}
              width={32}
              height={32}
              className="object-contain"
              unoptimized
            />
          ) : (
            <Image
              src="/map/icons/atm.webp"
              alt="ATM icon"
              width={32}
              height={32}
              className="object-contain"
              unoptimized
            />
          )}
        </div>
        <div className="flex-1 flex flex-col">
          <div className="font-semibold text-body-saans mb-2">{toTitleCase(location.name)}</div>
          <div className="flex flex-col gap-1">
            <div>{toTitleCase(location.address.street)}</div>
            <div>{toTitleCase(location.address.city)}</div>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="text-body-saans font-semibold mb-2">
            {userCoords && location.coordinates && (
              <>
                {getDistance(
                  userCoords.lat,
                  userCoords.lng,
                  location.coordinates.latitude,
                  location.coordinates.longitude,
                ).toFixed(1)}{' '}
                mi
              </>
            )}
          </div>
          <div className="flex flex-col gap-1">
            <div>
              {location.opening_hours &&
                (() => {
                  const { status } = getOpenStatus(location.opening_hours);
                  return (
                    <span
                      className={
                        status === 'Open' ? 'text-fern' : status === 'Closed' ? 'text-alert-500' : 'text-gray-500'
                      }>
                      {status}
                    </span>
                  );
                })()}
            </div>
            <div>
              {location.opening_hours &&
                (() => {
                  const { status } = getOpenStatus(location.opening_hours);
                  return status === 'Open' && isOpen247(location.opening_hours) ? <span>Open 24/7</span> : null;
                })()}
            </div>
          </div>
        </div>
      </div>
    </m.div>
  );
};
